import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { useLanguage } from './LanguageContext';
export function Layout() {
  const {
    t
  } = useLanguage();
  return <div className="min-h-screen bg-slate-50 flex justify-center sm:py-8 sm:px-4" data-id="element-65">
      <div className="w-full max-w-md bg-white min-h-screen sm:min-h-[850px] sm:h-[850px] sm:rounded-[40px] sm:shadow-2xl sm:border-[8px] sm:border-slate-900 overflow-hidden relative flex flex-col" data-id="element-66">
        <Header data-id="element-67" />
        <main className="flex-1 overflow-y-auto relative flex flex-col" data-id="element-68">
          <Outlet data-id="element-69" />
        </main>
        <footer className="shrink-0 flex items-center justify-center gap-1.5 py-1.5 bg-white border-t border-slate-100" data-id="element-70">
          <span className="text-[9px] font-medium text-slate-400 uppercase tracking-wider leading-none" data-id="element-71">
            {t('header.poweredBy')}
          </span>
          <img src="https://cdn.magicpatterns.com/uploads/18rAbKxJnyet4nsoqGxDaq/Biz_Card_Logo.png" alt="Docent Labs" className="h-3 w-auto opacity-80" data-id="element-72" />
        </footer>
      </div>
    </div>;
}